/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ListFilter = [
  ["path", { d: "M2 5h20" }],
  ["path", { d: "M6 12h12" }],
  ["path", { d: "M9 19h6" }]
];

export { ListFilter as default };
//# sourceMappingURL=list-filter.js.map
